import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BottomNavbar from "../components/BottomNavbar";
import { ajukanJurnalMingguan } from "../services/jurnalMingguanService";
import imageCompression from "browser-image-compression";

function InputJurnalMingguan() {
  const navigate = useNavigate();
  const [mingguKe, setMingguKe] = useState("");
  const [namaPekerjaan, setNamaPekerjaan] = useState("");
  const [perencanaan, setPerencanaan] = useState("");
  const [fotos, setFotos] = useState([]); // array of { file, deskripsi }
  const [loading, setLoading] = useState(false);

  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    };
    try {
      return await imageCompression(file, options);
    } catch (err) {
      console.error("Compression failed:", err);
      return file;
    }
  };

  const handleFotoChange = async (e) => {
    const files = Array.from(e.target.files);
    if (fotos.length + files.length > 4) {
      alert("Maksimal upload 4 foto.");
      return;
    }

    const compressedFiles = await Promise.all(files.map((file) => compressImage(file)));
    const newFotoObjects = compressedFiles.map((file) => ({ file, deskripsi: "" }));
    setFotos([...fotos, ...newFotoObjects]);
  };

  const updateDeskripsi = (index, value) => {
    const updated = [...fotos];
    updated[index].deskripsi = value;
    setFotos(updated);
  };

  const removeFoto = (index) => {
    const updated = [...fotos];
    updated.splice(index, 1);
    setFotos(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!mingguKe || !namaPekerjaan || !perencanaan || fotos.length === 0) {
      alert("Harap lengkapi semua isian.");
      return;
    }

    const formData = new FormData();
    formData.append("minggu_ke", mingguKe);
    formData.append("nama_pekerjaan", namaPekerjaan);
    formData.append("perencanaan_kegiatan", perencanaan);

    fotos.forEach((foto, index) => {
      formData.append(`foto[${index}][file]`, foto.file);
      formData.append(`foto[${index}][deskripsi]`, foto.deskripsi || `Foto ${index + 1}`);
    });

    setLoading(true);
    const result = await ajukanJurnalMingguan(formData);
    setLoading(false);

    if (result.success) {
      alert("Jurnal berhasil dikirim.");
      navigate("/jurnal-mingguan");
    } else {
      alert(result.message || "Terjadi kesalahan saat menyimpan jurnal.");
    }
  };

  return (
    <div className="container" style={{ paddingBottom: 80 }}>
      <div className="d-flex align-items-center my-4">
        <button className="btn p-0 text-dark" onClick={() => navigate(-1)}>←</button>
        <h5 className="ms-3 mb-0 fw-bold">Input Jurnal Mingguan</h5>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-semibold">Pilih Minggu</label>
          <select
            className="form-select"
            value={mingguKe}
            onChange={(e) => setMingguKe(e.target.value)}
            required
          >
            <option value="">-- Pilih --</option>
            {[...Array(25)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                Minggu ke-{i + 1}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Nama Pekerjaan</label>
          <textarea
            className="form-control"
            placeholder="Contoh: Membuat laporan harian..."
            rows={2}
            value={namaPekerjaan}
            onChange={(e) => setNamaPekerjaan(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Perencanaan Kegiatan</label>
          <textarea
            className="form-control"
            placeholder="Contoh: Menyusun rencana kegiatan minggu berikutnya..."
            rows={3}
            value={perencanaan}
            onChange={(e) => setPerencanaan(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Upload Foto Pelaksanaan (maks 4)</label>
          <div className="d-flex flex-wrap gap-2">
            {fotos.map((foto, index) => (
              <div key={index} style={{ width: 90 }}>
                <div className="position-relative" style={{ width: 90, height: 90 }}>
                  <img
                    src={URL.createObjectURL(foto.file)}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: 8,
                      border: "1px solid #ccc",
                    }}
                  />
                  <button
                    type="button"
                    className="btn-close position-absolute top-0 end-0"
                    style={{ backgroundColor: "white", fontSize: 10 }}
                    onClick={() => removeFoto(index)}
                  />
                </div>
                <input
                  type="text"
                  className="form-control mt-1"
                  placeholder={`Deskripsi foto ${index + 1}`}
                  value={foto.deskripsi}
                  onChange={(e) => updateDeskripsi(index, e.target.value)}
                />
              </div>
            ))}
            {fotos.length < 4 && (
              <label
                htmlFor="foto-upload"
                className="d-flex justify-content-center align-items-center"
                style={{
                  width: 90,
                  height: 90,
                  border: "1px dashed #ccc",
                  borderRadius: 8,
                  cursor: "pointer",
                }}
              >
                <i className="bi bi-camera" style={{ fontSize: 24 }}></i>
              </label>
            )}
            <input
              id="foto-upload"
              type="file"
              accept="image/*"
              multiple
              onChange={handleFotoChange}
              style={{ display: "none" }}
            />
          </div>
        </div>

        <button
          className="btn btn-primary w-100 mt-4"
          type="submit"
          disabled={loading}
          style={{ borderRadius: 12 }}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Menyimpan...
            </>
          ) : (
            <>
              <i className="bi bi-save me-2" />
              Simpan
            </>
          )}
        </button>
      </form>

      <BottomNavbar />
    </div>
  );
}

export default InputJurnalMingguan;
